import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { HttpService } from 'src/app/core/http/http.service';
import { AppLoadingService } from 'src/app/shared/services/apploading.service';
import { GeneralService } from 'src/app/shared/services/general.service';

@Component({
    selector: 'app-followers',
    templateUrl: './followers.component.html',
    styleUrls: ['./followers.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class FollowersComponent implements OnInit {

    dialogRef: MatDialogRef<any>;

    params:any={};
    title:any = '';
    id:any = '';

    constructor(
        protected als: AppLoadingService,
        public dialog: MatDialog,
        protected httpService: HttpService,
        protected gs: GeneralService
    ) {
        
    }

    ngOnInit() { 
        if(this.params?.type == 'profile')
            this.title = 'do perfil';

        if(this.params?.type == 'ads')
            this.title = 'de imóveis';

        if(this.params?.type == 'ad')
            this.title = 'do imóvel';

        this.id = this.params?.ad_id;
        
    }

}
